module.exports = __webpack_public_path__ + "img/warning.6498943a.png";